import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n";
import { ArrowUpRight } from "lucide-react";

export default function FinalCTA() {
  const { t } = useI18n();

  const go = () => {
    const el = document.getElementById("quote");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="final-cta-section"
      className="relative bg-black py-32 md:py-48 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=2200&q=85)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "grayscale(100%)",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black" />
      <div className="grain" />

      <div className="relative container mx-auto px-6 md:px-12 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.0 }}
          className="font-display text-5xl sm:text-7xl lg:text-9xl font-light tracking-tighter leading-[0.9] mb-10"
        >
          <div>{t.final_cta.title_1}</div>
          <div className="italic font-extralight text-gradient-lux">
            {t.final_cta.title_2}
          </div>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="text-white/65 max-w-xl mx-auto text-balance text-[15px] md:text-base"
        >
          {t.final_cta.subtitle}
        </motion.p>

        <motion.button
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.35 }}
          onClick={go}
          data-testid="final-cta-button"
          className="group mt-12 inline-flex items-center gap-3 bg-white text-black rounded-full px-9 py-5 text-sm uppercase tracking-[0.25em] font-medium hover:bg-zinc-200 transition-all hover:scale-[1.02]"
        >
          {t.final_cta.cta}
          <ArrowUpRight
            size={18}
            className="group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform"
          />
        </motion.button>
      </div>
    </section>
  );
}
